import { render, staticRenderFns } from "./ReferenceTab.vue?vue&type=template&id=0ca31c1c"
import script from "./ReferenceTab.vue?vue&type=script&lang=js"
export * from "./ReferenceTab.vue?vue&type=script&lang=js"
import style0 from "./ReferenceTab.vue?vue&type=style&index=0&id=0ca31c1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports